import { useCallback } from 'react'
import { usePermissionStore, Role, type Capability } from '@store/permissions'

export function usePermissions() {
  const role = usePermissionStore((state) => state.role)
  const hasCapability = usePermissionStore((state) => state.hasCapability)
  const setRole = usePermissionStore((state) => state.setRole)

  const canRead = useCallback(
    (resource: 'recipes' | 'executions' | 'logs') => {
      return hasCapability(`read:${resource}` as Capability)
    },
    [hasCapability],
  )

  const canWrite = useCallback(
    (resource: 'recipes' | 'executions') => {
      return hasCapability(`write:${resource}` as Capability)
    },
    [hasCapability],
  )

  const canDeploy = useCallback(() => {
    return hasCapability('deploy:recipes')
  }, [hasCapability])

  const canManageUsers = useCallback(() => {
    return hasCapability('manage:users')
  }, [hasCapability])

  return {
    role,
    setRole,
    canRead,
    canWrite,
    canDeploy,
    canManageUsers,
  }
}
